import { __extends } from "tslib";
import { CompareFacesRequest, CompareFacesResponse } from "../models/index";
import { deserializeAws_json1_1CompareFacesCommand, serializeAws_json1_1CompareFacesCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var CompareFacesCommand = /** @class */ (function (_super) {
    __extends(CompareFacesCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CompareFacesCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    CompareFacesCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: CompareFacesRequest.filterSensitiveLog,
            outputFilterSensitiveLog: CompareFacesResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CompareFacesCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1CompareFacesCommand(input, context);
    };
    CompareFacesCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1CompareFacesCommand(output, context);
    };
    return CompareFacesCommand;
}($Command));
export { CompareFacesCommand };
//# sourceMappingURL=CompareFacesCommand.js.map